var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-container"},[_c('div',{staticClass:"img-group"},[_c('img',{attrs:{"src":_vm.$store.state.static_img_url + 'pic/404bg.png'}}),_c('div',[_c('img',{attrs:{"src":_vm.$store.state.static_img_url + 'pic/ico_404.png'}}),_c('p',[_vm._v("抱歉！您访问的页面不存在")]),_c('router-link',{attrs:{"to":{ name: 'NewsList'}}},[_vm._v("返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }